import {
    ConfirmSignUp,
    Greetings,
    SignUp,
    TOTPSetup,
    VerifyContact,
    withAuthenticator,
} from 'aws-amplify-react';
import React from 'react';

import CustomForgotPassword from './CustomForgotPassword';
import CustomRequireNewPassword from './CustomRequireNewPassword';
import CustomSignIn from './CustomSignIn';

const CustomAuthenticator = ({ children }) => {
    return children;
};

export default withAuthenticator(CustomAuthenticator, false, [
    <Greetings key="Greetings" />,
    <CustomSignIn key="CustomSignIn" />,
    <CustomRequireNewPassword key="CustomRequireNewPassword" />,
    <SignUp key="SignUp" />,
    <ConfirmSignUp key="ConfirmSignUp" />,
    <VerifyContact key="VerifyContact" />,
    <CustomForgotPassword key="CustomForgotPassword" />,
    <TOTPSetup key="TOTPSetup" />,
]);
